import Link from "next/link";
import useFooterMenu from "../_hooks/useFooterMenu";
import FooterMenuGroup from "./FooterMenuGroup";
import FooterMenuHelp from "./FooterMenuHelp";
import { useEffect, useState } from "react";
import FooterSkeleton from "../_skeletons/FooterSkeleton";

const FooterMenu = ({ number }) => {
  const [shouldShowHelp, setShouldShowHelp] = useState(true); // ✅ moved up

  useEffect(() => {
    const updateVisibility = () => {
      const width = window.innerWidth;
      setShouldShowHelp(width <= 427 || width > 991);
    };

    updateVisibility(); // run on mount
    window.addEventListener("resize", updateVisibility);
    return () => window.removeEventListener("resize", updateVisibility);
  }, []);

  const { footerMenus, loading, error } = useFooterMenu();

  if (loading) return <FooterSkeleton />;
  if (error) return <FooterSkeleton />;

  const getMenuBySlug = (slug) => footerMenus.find((m) => m.slug === slug);

  const productMenu = getMenuBySlug("product");
  const companyMenu = getMenuBySlug("company");
  const solutionsMenu = getMenuBySlug("solutions");
  const securityMenu = getMenuBySlug("security");
  const legalMenu = getMenuBySlug("legal");

  const staticLinks = {
    product: [
      { slug: "user/dashboard", title: "Money Transfer" },
      { slug: "marketplace", title: "Marketplace" },
      { slug: "convert", title: "Currency Conversion" },
      { slug: "explore", title: "Explore" },
      { slug: "pages/wallet", title: "Wallet" },
      { slug: "exchange-rate", title: "Exchange rate" },
      { slug: "request-money", title: "Request Money" },
    ],
    company: [
      { slug: "pages/about-us", title: "About Us" },
      { slug: "blogs", title: "Blog" },
      { slug: "careers", title: "Careers" },
      { slug: "pages/code-of-conduct", title: "Code of Conduct" },
    ],
    solutions: [
      { slug: "payout-solutions", title: "Payout Solutions" },
      { slug: "open-banking", title: "Open Banking" },
    ],
  };

  return (
    <>
      {/* Desktop Footer */}
      <div
        className="row gy-5 main-footer-wrapper d-none d-lg-flex"
        style={{ gap: "25px" }}
      >
        <div className="col-lg-2 col-sm-4">
          <FooterMenuGroup
            title="Company"
            staticLinks={staticLinks.company}
            dynamicPages={companyMenu?.pages || []}
          />
        </div>
        <div className="col-xl-2 col-lg-3 col-sm-4">
          <FooterMenuGroup
            title="Product"
            staticLinks={staticLinks.product}
            dynamicPages={productMenu?.pages || []}
          />
        </div>
        <div className="col-lg-3 col-sm-4">
          <div className="footer-item-wrapper">
            <FooterMenuGroup
              title="Solutions"
              staticLinks={staticLinks.solutions}
              dynamicPages={solutionsMenu?.pages || []}
            />
            <FooterMenuGroup
              title="Security"
              dynamicPages={securityMenu?.pages || []}
            />
          </div>
        </div>
        <div className="col-lg-2 col-md-4 col-sm-8">
          <FooterMenuGroup
            title="Legal"
            dynamicPages={legalMenu?.pages || []}
          />
        </div>
        <div className="col-lg-2 col-sm-4">
          {shouldShowHelp && <FooterMenuHelp number={number} />}
        </div>
      </div>

      {/* Mobile Footer */}
      <div className="row gy-5 main-footer-wrapper two d-lg-none d-flex">
        <div className="col-3">
          <FooterMenuGroup
            title="Product"
            staticLinks={staticLinks.product}
            dynamicPages={[]}
          />
        </div>
        <div className="col-3">
          <FooterMenuGroup
            title="Company"
            staticLinks={staticLinks.company}
            dynamicPages={[]}
          />
        </div>
        <div className="col-3 ">
          <FooterMenuGroup
            title="Solutions"
            staticLinks={staticLinks.solutions}
            dynamicPages={[]}
          />
        </div>
        <div className="col-3">
          <FooterMenuHelp number={number} />
        </div>
        <div className="col-6 col-md-5">
          <FooterMenuGroup
            title="Security"
            dynamicPages={securityMenu?.pages || []}
          />
        </div>
        <div className="col-3 col-md-4">
          <FooterMenuGroup
            title="Legal"
            dynamicPages={legalMenu?.pages || []}
          />
        </div>
      </div>
    </>
  );
};

export default FooterMenu;
